import { render, staticRenderFns } from "./team-data.vue?vue&type=template&id=688197d6&scoped=true&"
import script from "./team-data.vue?vue&type=script&lang=js&"
export * from "./team-data.vue?vue&type=script&lang=js&"
import style0 from "./team-data.vue?vue&type=style&index=0&id=688197d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688197d6",
  null
  
)

export default component.exports